import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

import { Observable, of } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';

import { AuthService } from './auth.service';
import { Auth } from 'aws-amplify';

@Injectable({
  providedIn: 'root',
})

export class AuthGuard implements CanActivate {

  constructor(
  private auth: AuthService,
  private router: Router) { }

  // calls the AuthService isAuthenticated method, that returns an Observable<boolean>,
  // returns that value and depending on it allows/forbid access to the protected path
  canActivate(next: ActivatedRouteSnapshot,
              state: RouterStateSnapshot): Observable<boolean> {
     // alert("AuthGuard: \n canActivate method called...");     // DEBUG
     return this.auth.isAuthenticated().pipe(
        tap(isAuth => {
           // alert("isAuth = " + isAuth);     // DEBUG
           if (!isAuth) {
              // forbid access, redirect to login
              // alert("AuthGuard: \n attempted URL = " + state.url);           // DEBUG
              // alert("AuthGuard: \n FORBIDDEN, redirecting to login...");     // DEBUG
              this.router.navigate(['/login']);
           } else {
              // allow access
              // alert("AuthGuard: \n ALLOW");    // DEBUG
           }
        })
     );
  }  // end canActivate

} // end AuthGuard
